import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
table {
  /*
   * Override the font set by the Storeblocks table component.
   * We are still using the old version of the table component.
   * The new Pretzel table component uses the correct font.
   * Thus, we can remove this override when we switch to the new table component.
   */
  font-family: 'Storebrand Text', sans-serif !important;
}
`;
